import { useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const drafts = new Map<symbol, boolean>();
export function confirmDiscardDrafts(message = '当前内容尚未保存，是否放弃编辑并离开？') {
  return !Array.from(drafts.values()).some(Boolean) || window.confirm(message);
}

export function useDraftGuard(hasDraft: boolean) {
  useEffect(() => {
    const identity = Symbol('page-draft');
    drafts.set(identity, hasDraft);
    const unload = (event: BeforeUnloadEvent) => {
      if (Array.from(drafts.values()).some(Boolean)) { event.preventDefault(); event.returnValue = ''; }
    };
    window.addEventListener('beforeunload', unload);
    return () => {
      window.removeEventListener('beforeunload', unload);
      drafts.delete(identity);
    };
  }, [hasDraft]);
}

export function useGuardedNavigate() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return useCallback((target: string): boolean => {
    if (target === pathname) return true;
    if (!confirmDiscardDrafts()) return false;
    navigate(target);
    return true;
  }, [navigate, pathname]);
}
